export default "__VITE_ASSET__CVe8Ic_I__"